module.exports = __webpack_public_path__ + "static/media/repeatable-header-footer-on-preview.41b45ec9.png";